module.exports = __webpack_public_path__ + "img/icon_ai_processing.242c5b51.png";